import { render, staticRenderFns } from "./GridList.vue?vue&type=template&id=4022f364"
import script from "./GridList.vue?vue&type=script&lang=js"
export * from "./GridList.vue?vue&type=script&lang=js"
import style0 from "./GridList.vue?vue&type=style&index=0&id=4022f364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports